'use es6';

import { jsxs as _jsxs } from "react/jsx-runtime";
import { jsx as _jsx } from "react/jsx-runtime";
import { PureComponent } from 'react';
import PropTypes from 'prop-types';
import CustomWidgetPropTypes from 'DesignData/propTypes/customWidgets';
import { connect } from 'react-redux';
import FormattedMessage from 'I18n/components/FormattedMessage';
import FormattedReactMessage from 'I18n/components/FormattedReactMessage';
import { CUSTOM_WIDGET } from 'DesignData/enums/DesignAssetTypes';
import * as CosIndexConnectionsActions from 'DesignData/actions/CosIndexConnections';
import * as CustomWidgetEditorOptionsActions from 'DesignData/actions/CustomWidgetEditorOptions';
import * as cosIndexConnectionsSelectors from 'DesignData/selectors/cosIndexConnections';
import * as customWidgetEditorOptionsSelectors from 'DesignData/selectors/customWidgetEditorOptions';
import { createDependentsPath } from 'DesignData/helpers/routingHelper';
import UIRouterLink from 'ui-addon-react-router-dom/UIRouterLink';
import UIButton from 'UIComponents/button/UIButton';
import Small from 'UIComponents/elements/Small';

function makeMapStateToProps() {
  const getParentConnectionsByCategory = cosIndexConnectionsSelectors.makeGetParentConnectionsByCategory();
  return function mapStateToProps(state, props) {
    const isEditingGlobalContent = customWidgetEditorOptionsSelectors.getIsEditingGlobalContent(state, props);
    const parentConnections = getParentConnectionsByCategory(state, {
      assetId: props.customWidgetId
    });
    const dependentsCount = Object.keys(parentConnections).reduce((count, type) => {
      return count + Object.keys(parentConnections[type]).length;
    }, 0);
    return {
      isEditingGlobalContent,
      dependentsCount
    };
  };
}

const mapDispatchToProps = {
  fetchForParentConnections: CosIndexConnectionsActions.fetchForParentConnections,
  setIsEditingGlobalContent: CustomWidgetEditorOptionsActions.setIsEditingGlobalContent
};

const i18nKey = key => `DesignEditorsUI.customWidgetEditor.sidebar.main.globalAndSmartContent.${key}`;

class GlobalContent extends PureComponent {
  constructor(...args) {
    super(...args);

    this.onEditGlobalContent = () => {
      this.props.setIsEditingGlobalContent(this.props.customWidgetId, true);
    };
  }

  componentDidMount() {
    this.props.fetchForParentConnections(this.props.customWidgetId);
  }

  componentDidUpdate(prevProps) {
    if (this.props.customWidgetId !== prevProps.customWidgetId) {
      this.props.fetchForParentConnections(this.props.customWidgetId);
    }
  }

  renderDependentsMessage() {
    const {
      customWidgetId,
      dependentsCount
    } = this.props;

    if (!dependentsCount) {
      return null;
    }

    const dependentsLink = /*#__PURE__*/_jsx(UIRouterLink, {
      to: createDependentsPath(CUSTOM_WIDGET, customWidgetId),
      children: /*#__PURE__*/_jsx(FormattedMessage, {
        message: i18nKey('dependentsLink'),
        options: {
          count: dependentsCount
        }
      })
    });

    return /*#__PURE__*/_jsx(FormattedReactMessage, {
      message: i18nKey('dependentsLink.prefix'),
      options: {
        dependentsLink
      }
    });
  }

  render() {
    const {
      isEditingGlobalContent
    } = this.props;
    return /*#__PURE__*/_jsxs("div", {
      children: [/*#__PURE__*/_jsx("div", {
        children: /*#__PURE__*/_jsxs(Small, {
          children: [/*#__PURE__*/_jsx(FormattedMessage, {
            message: i18nKey('message')
          }), this.renderDependentsMessage()]
        })
      }), /*#__PURE__*/_jsx(UIButton, {
        className: "m-top-3",
        disabled: isEditingGlobalContent,
        onClick: this.onEditGlobalContent,
        size: "extra-small",
        use: "tertiary-light",
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: i18nKey(`editButton.globalAndSmart`)
        })
      })]
    });
  }

}

GlobalContent.propTypes = {
  customWidgetId: CustomWidgetPropTypes.customWidgetId.isRequired,
  isEditingGlobalContent: PropTypes.bool.isRequired,
  dependentsCount: PropTypes.number.isRequired,
  fetchForParentConnections: PropTypes.func.isRequired,
  setIsEditingGlobalContent: PropTypes.func.isRequired
};
export default connect(makeMapStateToProps, mapDispatchToProps)(GlobalContent);